export default __webpack_public_path__ + "static/home-banner-poster-c46fec0881189a3205ea1e96c21d1742.webp";